import { render, staticRenderFns } from "./InApp.vue?vue&type=template&id=3f8b8043&scoped=true"
import script from "./InApp.vue?vue&type=script&lang=js"
export * from "./InApp.vue?vue&type=script&lang=js"
import style0 from "./InApp.vue?vue&type=style&index=0&id=3f8b8043&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../frontAgencies/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8b8043",
  null
  
)

export default component.exports